var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVibration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    x: 405.333,
    y: 149.333,
    width: 42.667,
    height: 213.333
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    y: 192,
    width: 42.667,
    height: 128
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    x: 64,
    y: 149.333,
    width: 42.667,
    height: 213.333
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M352,64H160c-17.707,0-32,14.293-32,32v320c0,17.707,14.293,32,32,32h192c17.707,0,32-14.293,32-32V96 C384,78.293,369.707,64,352,64z M341.333,405.333H170.667V106.667h170.667V405.333z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    x: 469.333,
    y: 192,
    width: 42.667,
    height: 128
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVibration);
export default __webpack_public_path__ + "static/media/vibration.19750a146f1dd6166ad17a5f19b6987e.svg";
export { ForwardRef as ReactComponent };